var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconISignCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58887 8C6.58887 7.58579 6.92465 7.25 7.33887 7.25H8.10585C8.52007 7.25 8.85585 7.58579 8.85585 8V10.8345C8.85585 11.2487 8.52007 11.5845 8.10585 11.5845C7.69164 11.5845 7.35585 11.2487 7.35585 10.8345V8.75H7.33887C6.92465 8.75 6.58887 8.41421 6.58887 8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5835 10.8335C6.5835 10.4193 6.91928 10.0835 7.3335 10.0835H8.8737C9.28791 10.0835 9.6237 10.4193 9.6237 10.8335C9.6237 11.2477 9.28791 11.5835 8.8737 11.5835H7.3335C6.91928 11.5835 6.5835 11.2477 6.5835 10.8335Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68571 4.54791C8.50258 4.31577 8.21876 4.16675 7.90013 4.16675C7.25576 4.16675 6.7334 4.68911 6.7334 5.33348C6.7334 5.97785 7.25576 6.50022 7.90013 6.50022C8.54451 6.50022 9.06687 5.97785 9.06687 5.33348C9.06687 5.01486 8.91785 4.73104 8.68571 4.54791Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 6C0.25 2.82436 2.82436 0.25 6 0.25H10C13.1756 0.25 15.75 2.82436 15.75 6V10C15.75 13.1756 13.1756 15.75 10 15.75H6C2.82436 15.75 0.25 13.1756 0.25 10V6ZM6 1.75C3.65279 1.75 1.75 3.65279 1.75 6V10C1.75 12.3472 3.65279 14.25 6 14.25H10C12.3472 14.25 14.25 12.3472 14.25 10V6C14.25 3.65279 12.3472 1.75 10 1.75H6Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconISignCircle);
export default __webpack_public_path__ + "static/media/icon-i-sign-circle.7bde384162dc48506604532edaf263b8.svg";
export { ForwardRef as ReactComponent };